// extracted by mini-css-extract-plugin
export default {"header":"styles_header__4pMGA","main":"styles_main__Gc9y6","pagination":"styles_pagination__u1WS1","content":"styles_content__cD3RQ"};